
import React, { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Switch,
} from 'react-router-dom';
import routes from '../../router';
import RouteWithSubRoutes from '../../pages/RouteWithSubRoutes'
import cookies from '../../libs/util.cookies'
import { preloadBaiduMap } from '../../libs/baiduMap'

export default function RouteConfigExample() {
  useEffect(() => {
    if (cookies.get('token')) {
      preloadBaiduMap()
    }
  }, [])

  return (
    <Router>
      <div>
        
        <Switch>
          {
            routes.map( function(route, i) {
              return <RouteWithSubRoutes key={i} { ...route } />
            })
          }
        </Switch>
      </div>
    </Router>
  )
}